import TextAreaMaxWords from './TextAreaMaxWords';
export default TextAreaMaxWords;